module.exports = __webpack_public_path__ + "static/media/many people.f1fcdb2f.jpg";